export const parseDollarStringToNumber = (dollarString: string): number => {
  const dollarStringWithoutCommas = dollarString.replace(/,/g, "");
  const dollarStringWithoutDollarSign = dollarStringWithoutCommas.replace(
    "$",
    "",
  );
  const dollarStringAsNumber = parseFloat(dollarStringWithoutDollarSign);
  return dollarStringAsNumber;
};
